import React from "react";
import { ChooseCustomerView } from "./ChooseCustomer.View";
import { useChooseCustomer } from "./ChooseCustomer.Model";

export const ChooseCustomer = ({ }) => {
  return <ChooseCustomerView {...useChooseCustomer()} />
}
